import {
  faTrash,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons/roundButton/roundButton.component';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import {
  ContextMenuComponent, ContextMenuDefaultItem, ContextMenuItemCoreComponent,
} from '~/_shared/baseComponents/contextMenu';
import { useTranslation } from '~/_shared/utils/hooks';

export const ActiveDataLayerDeleteMenuComponent = ({
  onDeleteTemplate,
  onRemove,
}: Readonly<{
  onDeleteTemplate?: () => void;
  onRemove: () => void;
}>) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [t] = useTranslation();

  return (
    <ContextMenuComponent
      isFixed
      isVisible={isMenuOpen}
      onHide={() => setIsMenuOpen(false)}
      maxWidth={400}
      renderMenuContent={() => (
        <>
          {onDeleteTemplate && (
            <ContextMenuItemCoreComponent>
              <ContextMenuDefaultItem
                icon={faTrash}
                onClick={onDeleteTemplate}
                size="s"
                isDestructive
              >
                {t('dataLayersTool.delete.fromMapAndTemplates')}
              </ContextMenuDefaultItem>
            </ContextMenuItemCoreComponent>
          )}

          <ContextMenuItemCoreComponent>
            <ContextMenuDefaultItem
              icon={faXmark}
              onClick={onRemove}
              size="s"
              isDestructive
            >
              {t('dataLayersTool.delete.fromMapOnly')}
            </ContextMenuDefaultItem>
          </ContextMenuItemCoreComponent>
        </>
      )}
    >
      <RoundButtonComponent
        icon={faTrash}
        onClick={() => setIsMenuOpen(true)}
        size={RoundButtonSize.Small}
        buttonStyle={RoundButtonStyle.Danger}
      />
    </ContextMenuComponent>
  );
};
